import { render, staticRenderFns } from "./CompanyPaycheckSettingsForm.vue?vue&type=template&id=e5167b1a&scoped=true&"
import script from "./CompanyPaycheckSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./CompanyPaycheckSettingsForm.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyPaycheckSettingsForm.vue?vue&type=style&index=0&id=e5167b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5167b1a",
  null
  
)

export default component.exports